import NavBar from "../components/navbar";
import HeaderCarousel from "../components/headercarousel";
import ServiceCarousel from "../components/servicecarousel";
import OurTeam from "../components/ourteam";
import TechStack from "../components/techstack";
import ReviewCarousel from "../components/reviewcarousel";
import ContactForm from "../components/contactform";
import Footer from "../components/footer";
import OurWork from "../components/ourwork";
import AboutCompany from "../components/aboutus";
import SalesForceTechStack from "../components/salesForceTechStake";
import CRMServiceCarousel from "../components/crmServices";
import HeroAnimated from "../components/heroAnimated";
import OurClients from "../components/ourclient";

const componentMap = {
    navbar: NavBar,
    header: HeaderCarousel,
    services: ServiceCarousel,
    team: OurTeam,
    tech: TechStack,
    clients: OurClients,
    contactForm: ContactForm,
    footer: Footer,
    ourwork: OurWork,
    about: AboutCompany,
    salesforcetech: SalesForceTechStack,
    crmservices: CRMServiceCarousel,
    heroanimated: HeroAnimated,
    review: ReviewCarousel
};

export default componentMap;